const getMissingKeys = (config: object, requiredKeys: string[]) =>
  requiredKeys.filter((key) => !Object.keys(config).includes(key))

export default function validateConfigUrls(config: Window) {
  const missingVariables = getMissingKeys(config, requiredVariables)
  const missingUrls = getMissingKeys(config.apiUrls, requiredUrls)

  if (missingVariables.length > 0 || missingUrls.length > 0) {
    window.alert('Environment variables not configured')
  }

  missingVariables.forEach((variable) => {
    console.error('Variable not configured in environment: ' + variable)
  })

  missingUrls.forEach((variable) => {
    console.error('URL not configured in environment: ' + variable)
  })
}

const requiredVariables = [
  'waInteractionUrl',
  'waMasterdataUrl',
  'waEnv',
  'waitingInteractionFillUUID',
  'waitingTargetSituationUUID',
  'waitingTargetStatusUUID',
  'doneStatusUUID'
]

const requiredUrls = ['msLogin', 'msAuth', 'msPlatform']
